import React, { Component, } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import _ from 'lodash';

export const styles = {
    control: (styles, { isFocused }) => ({
        ...styles,
        borderColor: isFocused ? '#80bdff' : '#ced4da',
        boxShadow: isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
        lineHeight: '1',
        '&:hover': {
            borderColor: isFocused ? '#80bdff' : '#ced4da',
        }
    }),
    valueContainer: styles => ({
        ...styles,
        padding: '.375rem .75rem',
        height: '36px'
    }),
    placeholder: styles => ({
        ...styles,
        color: '#495057',
        marginLeft: '4px',
        marginRight: '2px'
    }),
    clearIndicator: styles => ({
        ...styles,
        padding: '4px',
        cursor: 'pointer'
    }),
    dropdownIndicator: (styles) => ({
        ...styles,
        padding: '4px',
        cursor: 'pointer'
    }),
    indicatorSeparator: (styles) => ({
        ...styles,
        marginTop: '2px',
        marginBottom: '2px',
        backgroundColor: '#ced4da'
    }),
    singleValue: styles => ({
        ...styles,
        height: '21px',
        padding: '3px 0'
    }),
    option: (styles, { isSelected }) => ({
        ...styles,
        ":hover": {
            backgroundColor: isSelected ? '#89aa11' : 'rgba(137, 170, 17, 0.44)'
        },
        backgroundColor: isSelected ? '#89aa11' : 'white',
        cursor: 'pointer',
        paddingTop: '0',
        paddingBottom: '0'
    }),
    menu: styles => ({
        ...styles,
        marginTop: '0',
        marginBottom: '0',
        borderRadius: '0'
    }),
    menuList: styles => ({
        ...styles,
        paddingTop: '0',
        paddingBottom: '0'
    })
};

class SelectWithSearch extends Component {
    getOptionByValue = (value) => {
        let option = _.find(this.props.options, ['value', value]);

        return option || null;
    };

    render() {
        return (
            <div>
                <Select
                    className={'select-with-search ' + (_.isNil(this.props.className) ? '' : this.props.className)}
                    value={this.getOptionByValue(this.props.value)}
                    options={this.props.options}
                    isClearable={true}
                    placeholder={this.props.placeholder}
                    styles={styles}
                    isDisabled={this.props.isDisabled}
                    onChange={this.handleChange}
                />
            </div>
        );
    }

    handleChange = (option) => {
        if (!option) {
            this.props.onChange(undefined);
            return;
        }

        this.props.onChange(option.value);
    };
}

SelectWithSearch.propTypes = {
    className: PropTypes.string,
    value: PropTypes.any,
    placeholder: PropTypes.any,
    isDisabled: PropTypes.bool,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
};

export default SelectWithSearch;


// WEBPACK FOOTER //
// ./src/components/commonComponents/selectWithSearch/SelectWithSearch.js